import { Box, Stack, StackProps, styled, TableRow } from '@mui/material';

export const CustomTableRow = styled(TableRow, {
  shouldForwardProp: (prop: string) => prop !== 'selected',
})<{
  selected?: boolean;
}>(
  ({ theme, selected }) => `
  cursor: pointer;
  background-color: ${selected ? 'rgba(2, 90, 197, 0.04)' : 'transparent'};
  transition: background-color 0.2s ease;

  td {
    border-bottom: 1px solid ${theme.palette.divider};
  }

  &:hover {
    background-color: ${
      selected ? 'rgba(2, 90, 197, 0.04)' : theme.palette.action.hover
    };
  }
`,
);

export const RowContainer = styled((props: StackProps) => (
  <Stack direction="row" spacing={1} {...props} />
))`
  align-items: center;
`;

export const ChipContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
`;
